export enum PipelineType {
  ORIGINATION = 'ORIGINATION',
  ACQUISITION = 'ACQUISITION',
}
export const pipelineTypeToLabel: {[value: string]: string} = {
  [PipelineType.ORIGINATION]: 'Origination',
  [PipelineType.ACQUISITION]: 'Acquisition',
};
